/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".list-inline li{display:inline!important}.map-filter-check{display:inline-block;padding-right:7px}.foot button{margin-left:5px}.map-list label{margin-bottom:5px}"];
export { styles as styles };
